









import { Component, Vue } from 'vue-property-decorator'
import axios from 'axios'
import { Spa2Route } from '@/ExternalRoutes'
import BaseIcon from '@/components/reusable-components/basics/BaseIcon.vue'

@Component({
    components: { BaseIcon },
})
export default class HeaderActionInbox extends Vue {
    unreadMessageCount = 0
    Spa2Route = Spa2Route

    mounted() {
        this.getUnreadMessagesCount()
    }

    async getUnreadMessagesCount() {
        let count = sessionStorage.getItem('inbox_unread_count')

        if (!count) {
            axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
            const response = await axios.get('/ekko/unread-count')
            count = response.data.count
            sessionStorage.setItem('inbox_unread_count', count || '0')
        }

        this.unreadMessageCount = Number(count)
    }
}
